import videojs from "maestro-videojs-vast";

import React from "react";
// import videojs from "maestro-videojs-vast/dist/maestroVideoJsVast.min.js";
import "maestro-videojs-vast/dist/maestroVideoJsVast.css";

export default class VideoReward extends React.Component {
  componentDidMount() {
    // instantiate Video.js
    // make sure you pass in a fallback empty src URL for the video
    this.player = videojs(this.videoNode, this.props, function onPlayerReady() {
      console.log("onPlayerReady", this);
    });
    this.player.ads();
    this.player.vast({
      url:
        "https://www.videosprofitnetwork.com/watch.xml?key=77bfa818dd175d0a5f1e4f03e0bb756f",
    });

    this.player.trigger("adcanplay");
  }

  // destroy player on unmount
  componentWillUnmount() {
    if (this.player) {
      this.player.dispose();
    }
  }

  // wrap the player in a div with a `data-vjs-player` attribute
  // so videojs won't create additional wrapper in the DOM
  // see https://github.com/videojs/video.js/pull/3856
  render() {
    return (
      <div>
        <div data-vjs-player>
          <video
            ref={(node) => (this.videoNode = node)}
            className="video-js"
          ></video>
        </div>
      </div>
    );
  }
}
